import {
  formatDeliveryDays,
  formatEmailCellPreview,
  formatMoqCellPreview,
  formatTokenCellPreview,
} from '../../lib/demCustomers';
import type { DemCustomer } from '../../types/dem';

type CustomerListRowProps = {
  customer: DemCustomer;
  selected?: boolean;
  onOpen: (customer: DemCustomer) => void;
};

export function CustomerListRow({ customer, selected = false, onOpen }: CustomerListRowProps) {
  const daysLabel = formatDeliveryDays(customer.allowed_days);
  const daysClass =
    daysLabel === 'No Delivery'
      ? 'dem-customer-days--none'
      : daysLabel === 'Everyday'
        ? ''
        : 'dem-customer-days--partial';

  const emailPreview = formatEmailCellPreview(customer.email);
  const tokenPreview = formatTokenCellPreview(customer.portal_token);
  const moqLabel = formatMoqCellPreview(customer.min_order);

  return (
    <button
      type="button"
      className={`dem-customer-row${selected ? ' dem-customer-row--selected' : ''}`}
      aria-pressed={selected}
      onClick={() => onOpen(customer)}
    >
      <span className="dem-customer-cell dem-customer-cell--code" title={customer.code}>
        {customer.code}
      </span>

      <span
        className={`dem-customer-cell dem-customer-cell--name dem-customer-cell--clip${customer.is_blocked ? ' dem-customer-cell--blocked' : ''}`}
        title={customer.name || undefined}
      >
        {customer.is_blocked ? <span className="dem-customer-cell__flag" aria-hidden>⛔</span> : null}
        {customer.name || '—'}
      </span>

      <span className="dem-customer-cell dem-customer-cell--clip dem-customer-cell--muted" title={emailPreview.title || undefined}>
        {emailPreview.text}
      </span>

      <span className="dem-customer-cell dem-customer-cell--moq" title={moqLabel === '—' ? undefined : moqLabel}>
        {moqLabel}
      </span>

      <span className={`dem-customer-cell dem-customer-cell--days ${daysClass}`} title={daysLabel}>
        {daysLabel}
      </span>

      <span className="dem-customer-cell dem-customer-cell--clip dem-customer-cell--muted" title={tokenPreview.title || undefined}>
        {tokenPreview.text}
      </span>
    </button>
  );
}
